import React, { useState } from 'react';
import { toast } from 'sonner';
import EmployeeLayout from '../../components/EmployeeLayout';
import { getEmployeeUser } from '../../lib/employeeAuth';
import employeeApi from '../../lib/employeeApi';

export default function SettingsPage() {
  const employee = getEmployeeUser();
  const [formData, setFormData] = useState({ old_password: '', new_password: '', confirm_password: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.new_password !== formData.confirm_password) {
      toast.error('Passwords do not match');
      return;
    }
    if (formData.new_password.length < 8) {
      toast.error('Password must be at least 8 characters');
      return;
    }
    try {
      await employeeApi.put('/api/employee/auth/change-password', { old_password: formData.old_password, new_password: formData.new_password });
      toast.success('Password changed successfully');
      setFormData({ old_password: '', new_password: '', confirm_password: '' });
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to change password');
    }
  };

  return (
    <EmployeeLayout>
      <div className="p-8">
        <h1 className="text-2xl font-bold text-navy-900 mb-6">Settings</h1>
        <div className="max-w-2xl bg-white rounded-xl border p-6">
          <h3 className="font-semibold text-navy-800 mb-4">Change Password</h3>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div><label className="block text-sm font-medium mb-2">Current Password</label><input type="password" required value={formData.old_password} onChange={(e) => setFormData({ ...formData, old_password: e.target.value })} className="w-full px-4 py-2 border border-charcoal-200 rounded-xl" /></div>
            <div>
              <label className="block text-sm font-medium mb-2">New Password</label>
              <input type="password" required minLength="8" value={formData.new_password} onChange={(e) => setFormData({ ...formData, new_password: e.target.value })} className="w-full px-4 py-2 border border-charcoal-200 rounded-xl" />
              <p className="text-xs text-neutral-600 mt-1">Min 8 characters, include uppercase, lowercase, number, special char</p>
            </div>
            <div><label className="block text-sm font-medium mb-2">Confirm Password</label><input type="password" required value={formData.confirm_password} onChange={(e) => setFormData({ ...formData, confirm_password: e.target.value })} className="w-full px-4 py-2 border border-charcoal-200 rounded-xl" /></div>
            <button type="submit" className="px-6 py-2 bg-pink-600 text-white rounded-xl hover:bg-pink-700">Change Password</button>
          </form>
        </div>
      </div>
    </EmployeeLayout>
  );
}